module.exports = __webpack_public_path__ + "static/media/taggis-hub-logo.94cf1d53.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/taggis-hub-logo.svg
// module id = 67
// module chunks = 3